import React from 'react';

import { Box, Typography } from '@mui/material';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';

import { palette } from 'themeV5/palette';

import type { Column } from 'api/shared/models';

import ColumnOptions from '../ColumnOptions';
import { styles } from '../styles';

interface Props {
  columns: Column[];
  onClick: (column: Column) => void;
  moveRows?: (rowIndex: number, newIndex: number) => void;
  handleSort?: (column: Column) => void;
}

const MyColumns = ({ columns, onClick, moveRows, handleSort }: Props) => {
  return (
    <Box style={{ backgroundColor: palette.common.white }}>
      <Typography variant="h6" sx={styles.headerColumn}>
        <DoneOutlinedIcon style={{ marginRight: 8 }} /> Columnas
      </Typography>
      <ColumnOptions
        columns={columns}
        onClick={onClick}
        addDragAndDrop
        moveRows={moveRows}
        handleSort={handleSort}
      />
    </Box>
  );
};

export default MyColumns;
